export default class DtoUserUsageStatisticItem {
    constructor(obj) {
        this.stationType = obj.stationType
        this.functionnality = obj.functionnality
        this.nbAccess = obj.nbAccess
        this.lastAccess = obj.lastAccess
        this.headers = ['stationType', 'functionnality', 'nbAccess', 'lastAccess']
    }
}